/**
 * Pre-compiled pt-BR messages for Dialog
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { closeTrigger: `Fechar caixa de diálogo` };
